import { render, staticRenderFns } from "./ItemPowerForm.vue?vue&type=template&id=163aa0c9&scoped=true"
import script from "./ItemPowerForm.vue?vue&type=script&lang=js"
export * from "./ItemPowerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163aa0c9",
  null
  
)

export default component.exports